/* ============================================================
   KLOHEMA — Interacciones de la página de producto
   Galería con zoom/lupa, lightbox, variantes, cantidad
   ============================================================ */
(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* --- Selección de variantes ----------------------------- */
  document.querySelectorAll("[data-kl-group]").forEach((group) => {
    group.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-val]");
      if (!btn || !group.contains(btn)) return;
      group.querySelectorAll("[data-val]").forEach((b) => b.setAttribute("aria-pressed", "false"));
      btn.setAttribute("aria-pressed", "true");
      const scope = group.closest(".kl-pdp__info") || document;
      const out = scope.querySelector(group.getAttribute("data-out"));
      if (out) out.textContent = btn.dataset.val;
    });
  });

  /* --- Cantidad ------------------------------------------- */
  document.querySelectorAll(".kl-qty").forEach((qty) => {
    const input = qty.querySelector("input");
    qty.querySelectorAll("button").forEach((b) => {
      b.addEventListener("click", () => {
        let v = parseInt(input.value, 10) || 1;
        v += b.dataset.step === "up" ? 1 : -1;
        input.value = Math.max(1, Math.min(20, v));
      });
    });
  });

  /* --- Lightbox ------------------------------------------- */
  let lb, lbImg, lbCount, gallery = [], idx = 0;
  function buildLightbox() {
    lb = document.createElement("div");
    lb.className = "kl-lightbox";
    lb.innerHTML =
      '<button class="lb-x" aria-label="Cerrar">&times;</button>' +
      '<button class="lb-nav lb-prev" aria-label="Anterior">&#8249;</button>' +
      '<img alt="">' +
      '<button class="lb-nav lb-next" aria-label="Siguiente">&#8250;</button>' +
      '<div class="lb-count"></div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector("img");
    lbCount = lb.querySelector(".lb-count");
    const show = () => { lbImg.src = gallery[idx]; lbCount.textContent = (idx + 1) + " / " + gallery.length; };
    const close = () => lb.classList.remove("show");
    lb.querySelector(".lb-x").addEventListener("click", close);
    lb.querySelector(".lb-prev").addEventListener("click", (e) => { e.stopPropagation(); idx = (idx - 1 + gallery.length) % gallery.length; show(); });
    lb.querySelector(".lb-next").addEventListener("click", (e) => { e.stopPropagation(); idx = (idx + 1) % gallery.length; show(); });
    lb.addEventListener("click", (e) => { if (e.target === lb || e.target === lbImg) close(); });
    document.addEventListener("keydown", (e) => {
      if (!lb.classList.contains("show")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") lb.querySelector(".lb-prev").click();
      if (e.key === "ArrowRight") lb.querySelector(".lb-next").click();
    });
    lb._show = show;
  }
  function openLightbox(srcs, start) {
    if (!lb) buildLightbox();
    gallery = srcs.filter(Boolean); idx = start || 0;
    if (!gallery.length) return;
    lb._show(); lb.classList.add("show");
  }

  /* --- Galería: lupa + lightbox --------------------------- */
  document.querySelectorAll(".kl-pdp__shot").forEach((shot) => {
    const img = shot.querySelector("img");
    if (!img) return;

    if (!reduce && window.matchMedia("(hover: hover)").matches) {
      const lens = document.createElement("div");
      lens.className = "zoom-lens";
      shot.appendChild(lens);
      const ZOOM = 2.2;
      shot.addEventListener("pointerenter", () => {
        if (img.src) { lens.style.backgroundImage = "url('" + img.src + "')"; shot.classList.add("lens-on"); }
      });
      shot.addEventListener("pointermove", (ev) => {
        const r = shot.getBoundingClientRect();
        const x = ev.clientX - r.left, y = ev.clientY - r.top;
        lens.style.left = x + "px";
        lens.style.top = y + "px";
        lens.style.backgroundSize = (r.width * ZOOM) + "px " + (r.height * ZOOM) + "px";
        lens.style.backgroundPosition = "-" + (x * ZOOM - 90) + "px -" + (y * ZOOM - 90) + "px";
      });
      shot.addEventListener("pointerleave", () => shot.classList.remove("lens-on"));
    }

    shot.addEventListener("click", () => {
      const root = shot.closest(".kl-pdp") || document;
      const srcs = [...root.querySelectorAll(".kl-pdp__shot img")].map((i) => i.src);
      const start = [...root.querySelectorAll(".kl-pdp__shot")].indexOf(shot);
      openLightbox(srcs, Math.max(0, start));
    });
  });
})();
